
import { z } from "zod";

export const TagColorHexValues = ["EAF7F9", "EEF7EE", "F0F0F0", "F0FBFF", "F3EEF9", "F7F7F7", "FCEEFB", "FDF9EA", "FEEEEE", "FEF5E8"] as const;
export const TagColorHexSchema = /* @__PURE__ */ z.enum(TagColorHexValues);
export const TagColorHex: (typeof TagColorHexSchema)["enum"] = { "EAF7F9": "EAF7F9", "EEF7EE": "EEF7EE", "F0F0F0": "F0F0F0", "F0FBFF": "F0FBFF", "F3EEF9": "F3EEF9", "F7F7F7": "F7F7F7", "FCEEFB": "FCEEFB", "FDF9EA": "FDF9EA", "FEEEEE": "FEEEEE", "FEF5E8": "FEF5E8" };
export type TagColorHex = (typeof TagColorHexValues)[number];
export const TagColorHexDisplayNames = { "EAF7F9": "Teal",
"EEF7EE": "Green",
"F0F0F0": "Dark Gray",
"F0FBFF": "Blue",
"F3EEF9": "Purple",
"F7F7F7": "Gray",
"FCEEFB": "Pink",
"FDF9EA": "Yellow",
"FEEEEE": "Red",
"FEF5E8": "Orange", } satisfies Record<TagColorHex, string>;
